import React from 'react';

const Members: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="text-3xl font-bold text-navy-950 dark:text-white mb-8">
        Member Directory
      </h1>
      <div className="card">
        <p className="text-gray-600 dark:text-gray-300">
          Member directory coming soon...
        </p>
      </div>
    </div>
  );
};

export default Members;
